<template>
  <div class="vipOverview">
    <div class="vipOverview-name">
      <span>会员概览</span>
    </div>
    <el-radio-group v-model="radio1" size="small">
      <el-radio-button label="0">所有会员</el-radio-button>
      <el-radio-button label="1">普通卡</el-radio-button>
      <el-radio-button label="2">金卡</el-radio-button>
    </el-radio-group>
    <div class="swiper_card_group">
      <swiper :options="swiperOption" class="swiper-box">
        <swiper-slide class="swiper-item" v-for="(item,index) in vipStatistics" :key="index">
          <div class="card" :class="swiperIdx == index?'active':''" @click="swiperIdx=index">
            <div class="recommend-crowd-block__head">
              <div class="title">{{item.handline}}</div>
            </div>
            <div class="recommend-crowd-block__body">{{item.num}}</div>
            <div class="width100">较前一日</div>
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </div>
    <div id="chartLineBox" style="width: 100%;height: 300px;"></div>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import echarts from "echarts";
export default {
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      radio1: "0",
      swiperOption: {
        direction: "horizontal",
        slidesPerView: 7,
        slidesPerGroup: 7,
        spaceBetween: 0,
        loop: false,
        loopFillGroupWithBlank: true,
        mousewheel: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      },
      swiperIdx: "0",
      vipStatistics: [
        {
          handline: "累积会员数",
          num: "0"
        },
        {
          handline: "新增会员数",
          num: "0"
        },
        {
          handline: "支付会员数",
          num: "0"
        },
        {
          handline: "储值会员数",
          num: "0"
        },
        {
          handline: "领券会员数",
          num: "0"
        },
        {
          handline: "会员支付金额(元)",
          num: "0"
        },
        {
          handline: "会员支付订单数",
          num: "0"
        },
        {
          handline: "会员客单价(元)",
          num: "0"
        }
      ]
    };
  },
  mounted() {
    this.initMapData();
  },
  methods: {
    initMapData() {
      console.log(1212);
      this.chartLine = echarts.init(document.getElementById("chartLineBox"));

      // 指定图表的配置项和数据
      var option = {
        tooltip: {
          //设置tip提示
          trigger: "axis"
        },
        grid: { // 图格配置
          left: "40px",
          right: "30px"
        },
        legend: {
          //设置区分（哪条线属于什么）
          data: ["累计会员数"]
        },
        color: ["#3AA1FF"], //设置区分（每条线是什么颜色，和 legend 一一对应）
        xAxis: {
          //设置x轴
          type: "category",
          alignWithLabel:true,
          boundaryGap: false, //坐标轴两边不留白
          data: [
            "2019-1-1",
            "2019-2-1",
            "2019-3-1",
            "2019-4-1",
            "2019-5-1",
            "2019-6-1",
            "2019-7-1"
          ],
          name: "", //X轴 name
          nameTextStyle: {
            //坐标轴名称的文字样式
            color: "#3AA1FF",
            fontSize: 16,
            padding: [0, 0, 0, 20]
          },
          axisLine: {
            //坐标轴轴线相关设置。
            lineStyle: {
              color: "#3AA1FF"
            }
          }
        },
        yAxis: {
          name: "",
          nameTextStyle: {
            color: "#3AA1FF",
            fontSize: 16,
            padding: [0, 0, 10, 0]
          },
          axisLine: {
            lineStyle: {
              color: "#3AA1FF"
            }
          },
          type: "value"
        },
        series: [
          {
            name: "累计会员数",
            data: [120, 200, 150, 80, 70, 110, 130],
            type: "line",
            lineStyle: {
              normal: {
                color: "#3AA1FF"
              }
            }
          }
        ]
      };

      // 使用刚指定的配置项和数据显示图表。
      this.chartLine.setOption(option);
    }
  }
};
</script>

<style lang="scss" scoped>
.vipOverview {
  padding: 16px;
  background: #fff;
  margin-bottom: 14px;

  .vipOverview-name {
    font-size: 20px;
    font-weight: 500;
    line-height: 24px;
    height: 24px;
    margin-bottom: 20px;
  }

  .swiper_card_group {
    position: relative;
    padding: 15px 25px;
    .swiper-box {
      width: 100%;
      height: 100%;
      margin: 0 auto;
    }
    .swiper-item {
      height: 100%;
      text-align: center;
      font-size: 18px;
      background: #fff;
      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      -webkit-justify-content: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center;
      align-items: center;
      .card {
        min-width: 210px;
        min-height: 120px;
        margin: 0 10px 16px 0;
        padding: 20px 15px 16px 16px;
        display: flex;
        flex-direction: column;
        border: 1px solid #dcdee0;
        border-radius: 4px;
        .recommend-crowd-block__head {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          margin-bottom: 15px;
          .title {
            font-size: 14px;
            font-weight: 400;
            line-height: 16px;
          }
        }
        .recommend-crowd-block__body {
          text-align: left;
          font-size: 20px;
          color: #333;
          margin-bottom: 15px;
        }
        .width100 {
          text-align: left;
          font-size: 14px;
          color: #969799;
        }
      }
      .active {
        border-color: #155bd4;
        background-color: #edf4ff;
      }
    }
    .swiper-button-prev {
      left: 0px !important;
    }
    .swiper-button-next {
      right: 0px !important;
    }
    .swiper-button-next,
    .swiper-button-prev {
      background-size: 12px 44px;
    }
  }
}
</style>
